import type { WebsiteHeaderPhotoSchema_PhotoArch } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_ARCH_DEFAULT: WebsiteHeaderPhotoSchema_PhotoArch = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoArch-v1_1_1.json',
  presentationLayout: 'photoArch',
  photos: [],
};
